import { SvgIcon } from '@material-ui/core'

export default (props) => (
  <SvgIcon {...props} viewBox='0 0 1000 1000'>
    <path d='m212,842l630,-630q10,-11 13,-21t-2,-16l-28,-28q-5,-5 -15,-2t-21,13l-631,630q-10,11 -13,22t2,15l28,28q5,5 16,2t21,-13z' />
  </SvgIcon>
)
